var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vue-apex-charts',{staticClass:"chart",attrs:{"options":_vm.options,"series":_vm.options.series,"height":"380"}})}
var staticRenderFns = []

export { render, staticRenderFns }